<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<dialog-titlebar
	[title]="templateStringList.MULTI_SELECT_MENU_EDIT_LOCATIONS"
	[icon]="'location_on'"
	[isCloseButton]="false"
>
</dialog-titlebar>

<mat-dialog-content>
	<p>{{ templateStringList.TICKET_EDIT_LOCATIONS_DIALOG_TEXT }}</p>
	<mat-form-field subscriptSizing="dynamic">
		<mat-label>{{ templateStringList.PROJECT_ITEM_LOCATION_SINGULAR }}</mat-label>
		<mat-select [formControl]="selectedLocation">
			<mat-option *ngFor="let location of locationList$ | async" [value]="location.value">
				<div><span class="select-color-cell no-print {{ location.value }}"></span> {{ location.label }}</div>
			</mat-option>
		</mat-select>
	</mat-form-field>
</mat-dialog-content>

<button-footer
	(buttonSaveOrClose)="handleItemEvent({ type: 'Save', event: $event })"
	[disabled]="!selectedLocation.dirty"
	[saveOrCloseButtonText]="templateStringList.UICONTROL_TEXT_SAVE | uppercase"
>
	<button
		middleButton
		mat-button
		color="primary"
		(click)="handleItemEvent({ type: 'Cancel', event: $event })"
	>
		{{ templateStringList.UICONTROL_TEXT_CANCEL | uppercase }}
	</button>
</button-footer>
